<template>
    <div class="footer">
        <div class="flex-aligne-justifyb footer-msg">
            <div class="msg-left">
                <div class="flex-alignc mb-10" @click="callPhone">
                    <img src="@/assets/phone.png" />
                    服务咨询邮箱
                    <div class="phone">hfbeeyy@163.com</div>
                </div>
                <div class="flex-alignc">
                    <img src="@/assets/location.png" />
                    公司地址：安徽省合肥市高新区创新大道与菖蒲路交口大数据产业园A1栋505室；
                </div>
            </div>
            <div v-show="isQRCode" class="msg-right flex-alignc">
                <div class="flex-column-center item">
                    <div class="code mb-10">
                        <img src="@/assets/qrcode.png" />
                    </div>
                    <div>微信小程序</div>
                </div>
                <div class="flex-column-center item ml-30">
                    <div class="code mb-10">
                        <img src="@/assets/qrcode.png" />
                    </div>
                    <div>微信公众号</div>
                </div>
            </div>
        </div>
        <div class="footer-text text-center pt-20 pb-20">
            copyright   © 合肥蜜蜂有约科技有限公司
        </div>
        <img class="pointer top-img" src="@/assets/top.png" @click="goTop" />
    </div>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    import { reactive,ref,watch,computed  } from 'vue';
    const router = useRouter()
    // 页面回到顶部（滚动效果）
    function goTop () {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 0) {
            const timeTop = setInterval(() =>{
                document.documentElement.scrollTop = document.body.scrollTop = scrollTop -= 50; //一次减50往上滑动
                if (scrollTop <= 0) {
                    clearInterval(timeTop);
                }
            },
            10); //定时调用函数使其更顺滑
        }
    }
    let isQRCode = ref(true)
    const nowPath = computed(() => {
        return router.currentRoute.value.path
    })
    // 监听当前路由
    watch(nowPath,(newValue) => {
        if(newValue == '/principal/principal') {
            isQRCode.value = false
        }else{
            isQRCode.value = true
        }
    },{immediate:true,deep:true})
    
    
    function callPhone() {
        const a = document.createElement("a");
        a.href = "tel:400 099 7596"
        a.click();
    }
</script>

<style lang="scss">
.footer {
    position: relative;
    background: url(@/assets/footer.png) no-repeat;
    background-size: 100% 100%;
    width: 100%;
    .footer-msg {
        border-bottom: 1px solid #CCCCCC;
        padding: 100px 360px 26px;
        .msg-left {
            font-size: 14px;
            color: #FFFFFF;
            line-height: 25px;
            img {
                width: 16px;
                height: 16px;
                margin-right: 10px;
            }
            .phone {
                font-size: 18px;
                font-weight: bold;
                padding-left: 10px;
            }
        }
        .msg-right {
            .item {
                font-size: 12px;
                color: #FFFFFF;
                .code {
                    padding: 10px;
                    // border: 1px solid #FFFFFF;
                    img {
                        width: 90px;
                        height: 90px;
                    }
                }
            }
        }
    }
    .footer-text {
        font-size: 12px;
        color: #FFFFFF;
    }
    .top-img {
        position: absolute;
        top: 100px;
        right: 50px;
        width: 54px;
        height: 54px;
    }
}
</style>